import {ValueObject} from '@s-ui/domain'

export class VehicleOffersListValueObject extends ValueObject {
  /**
   * @param {Array<VehicleOfferValueObject>} items
   * */
}
